// Jumbo 60 — semántica de "ventana dinámica" concentrada en un solo lugar.
// El rótulo de la ventana cambia según si la vista es dinámica o no.
// El módulo NO sabe de dónde viene el flag (isDynamicWindow por orden /
// is_dynamic_windows por sala): recibe un booleano ya resuelto y solo decide el texto.

export const WINDOW_LABELS = {
    static: 'Ventana Entrega',
    dynamic: 'Ventana de inicio de preparación'
};

export const getWindowLabel = (isDynamic, selectedSla = null) => {
    if (selectedSla === 'Click al Auto') return WINDOW_LABELS.static;
    return isDynamic ? WINDOW_LABELS.dynamic : WINDOW_LABELS.static;
};
